import { Component, Input, Output, EventEmitter } from '@angular/core';
import { timer } from 'rxjs';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent {

  @Input() interval: number;

  @Output() onComplete = new EventEmitter();

  public countdown: string;
  private countdownObservable: any;

  private actual: number;

  constructor() { }

  stop(): void {
    if (this.countdownObservable) {
      this.countdownObservable.unsubscribe();
    }
  }

  start(): void {
    this.restart();
  }

  restart(): void {

    this.actual = this.interval;

    this.countdown = this.getTime();

    if (this.countdownObservable) {
      this.countdownObservable.unsubscribe();
    }


    this.countdownObservable = timer(1000, 1000).subscribe(() => {
      this.manipulateInterval();
      this.countdown = this.getTime();
      if (this.actual === 0) {
        this.countdownObservable.unsubscribe();
        this.countdownCompleted();
      }
    });
  }

  countdownCompleted(): void {
    this.onComplete.emit();
  }

  private getTime(): string {
    if (this.actual < 0) {
      this.actual = Math.abs(this.actual);
    }
    const hours = Math.floor(this.actual / 3600);
    const minutes = Math.floor((this.actual - (hours * 3600)) / 60);
    const seconds = (this.actual - (hours * 3600) - (minutes * 60));
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  private manipulateInterval() {
    this.actual--;
  }


}
